import "ngstorage";

//'phoneMobile',
const COMPLETE_PROFILE_FIELDS = ["firstName", "lastName", "nickname"];
const VERIFY_PHONE_FIELDS = ["phoneMobile"];
const LOCATION_FIELDS = ["streetLine1", "zipCode", "city", "state"];
const WORK_ELIGIBILITY_FIELDS = ["ssn", "dateBirth"];
const EMAILREGEX = /^([!#$%&*+-\/=?^`'|{}~\w_.]{1,64}?)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class ApplyProfileModalController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    SecurityService,
    SignonService,
    SignupValidator,
    TrackingService,
    $rootScope,
    $scope,
    $location,
    $timeout,
    $window,
    $companies,
    Messagingv2Service,
    EventsService,
    JobsService,
    SocialService,
    IterableService,
    ProfileService,
    $env,
    validation
  ) {
    this.name = "applyprofilemodal";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.$security = SecurityService;
    this.$window = $window;
    this.$location = $location;
    this.payload = {};
    this.$signon = SignonService;
    this.$social = SocialService;
    this.$iterable = IterableService;
    this.$timeout = $timeout;
    this.validator = SignupValidator;
    this.validation = {};
    this.$jobs = JobsService;
    this.uber_forward = false;
    this.setVerificationNoti = false;
    this.$events = EventsService;
    this.currentUser = this.$auth.getUserData();
    this.$scope = $scope;
    this.$tracking = TrackingService;
    this.$messagingv2 = Messagingv2Service;
    this.$companies = $companies;
    this.$profile = ProfileService;
    this.applicationIsSending = false;
    this.$env = $env;
    this.showReqs = false;
    this.mobile_UI = {};
    this.buttonDisabled = false;
    this.smsAgreementVal = false;
    this.userNeedsToSignIn = false;
    this.canValidate = false;
    this.$timeout(() => (this.canValidate = true), 1000);
    this.applicationDisabled = false;
    this.pref_jobble_types = [];
    this.user = {
      first_name: null,
      last_name: null,
      email: null,
      zip_code: null,
      password: null,
    };
    this.errors = {};

    console.log("profile location", this.$profile.LOCATION, this.$profile.STATUS_MAP[this.$profile.LOCATION]);

    this.ui_user_model = {
      nickname: null,
      firstName: null,
      lastName: null,
      homeContactInfo: {
        phoneMobile: null,
        streetLine1: null,
        zipCode: null,
        city: null,
        state: null,
      },
      ssn: null,
      dateBirth: null,
    };

    this.SetApplyProfileJobListener = this.$rootScope.$on("SetApplyProfileJob", ($event, params) => {
      this.$timeout(() => {
        this.showReqs = false;
        this.jobble = params.job;
        this.isSaveBankAccountDisabled = false;
        if (this.jobble.partnerPostContent === null) {
          this.jobble.is_partner_post = false;
        } else {
          this.jobble.is_partner_post = true;
        }
      });
    });

    this.SetApplicationQuestionsListener = this.$rootScope.$on("SetApplicationQuestions", ($event, params) => {
      if (params.forward) {
        this.uber_forward = true;
        this.jobble = params.data;
      }

      if (params.user_just_registered) {
        this.just_registered = true;
      }
      if (params.from_regi) {
        this.currentUser = params.from_regi;
      }
      if (params.data.partnerPostContent) {
        this.is_partner_post = true;
      }
      this.errorText = null;
      this.questions = [];
      this.questionsLoaded = false;

      if (this.currentUser) {
        if (this.is_partner_post === true) {
          this.sendUserToPartnerPost();
          return;
        }
        this.setSurveyQuestionsForJob(params);
        if (!this.currentUser.isVerified && !params.from_regi) {
          let dontShowWarning = true;
          this.userVerified = false;
          this.verify(dontShowWarning);
          this.setVerificationNoti = true;
        } else {
          this.userVerified = true;
          this.setVerificationNoti = false;
        }
      } else {
        this.noUser = true;
        this.jobble = params.data;
        this.button_type = params.button_type;
        this.loadSignOnButtons();
      }
    });

    this.ClearApplicationQuestionsListener = this.$rootScope.$on("ClearApplicationQuestions", ($event, params) => {
      this.clearQuestions();
    });

    this.UserUpdateTriggerListener = this.$rootScope.$on(this.$auth.USER_UPDATE_TRIGGER, ($event, user) => {
      this.currentUser = user;
      this.$timeout(() => {
        this.canUserApplyToShiftBasedJobs(true);
      });
    });

    this.SetNewUserForJobBoardListener = this.$rootScope.$on("SetNewUserForJobBoard", ($event, params) => {
      this.currentUser = params.user;
      this.$timeout(() => {
        this.getMostRecentUser();
      });
    });

    this.SetDataForVerificationListener = this.$rootScope.$on("SetDataForVerification", ($event, params) => {
      this.canUserApplyToShiftBasedJobs();
    });

    this.$scope.$on("$destroy", this.SetApplyProfileJobListener);
    this.$scope.$on("$destroy", this.SetDataForVerificationListener);
    this.$scope.$on("$destroy", this.SetNewUserForJobBoardListener);
    this.$scope.$on("$destroy", this.ClearApplicationQuestionsListener);
    this.$scope.$on("$destroy", this.SetApplicationQuestionsListener);
    this.$scope.$on("$destroy", this.UserUpdateTriggerListener);

    this.states = {
      values: [
        "--",
        "AL",
        "AK",
        "AS",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "DC",
        "FL",
        "GA",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "OH",
        "OK",
        "OR",
        "PA",
        "PR",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
    };

    this.partnerEmail = this.$localStorage.partnerEmail;

    this.getJobbleTypes().then(() => {
      if (this.currentUser) {
        this.$timeout(() => {
          this.canUserApplyToShiftBasedJobs();
        });
      }
    });

    this.paymentReady = false;

    if (this.currentUser) {
      this.getPaymentInfo().then((response) => {
        this.handlePaymentResponse(response.data);
      });
    }

    this.cardType = "bank";

    const thisYear = new Date().getFullYear();
    const allYears = [thisYear.toString()];

    for (let i = 1; i < 15; i++) {
      allYears.push((thisYear + i).toString());
    }
    this.stateList = [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DC",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
    ];
    this.expYears = {value: thisYear.toString(), values: allYears};
    this.expMonths = {
      value: "01",
      values: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
    };

    this.GetNewPaymentInfoListener = this.$rootScope.$on("GetNewPaymentInfo", ($event, params) => {
      if (params.data.error) {
        this.handleError(params.data.response);
      } else {
        this.getPaymentInfo(params, true).then((response) => {
          this.handlePaymentResponse(response.data, true, params);
        });
      }
    });

    this.$scope.$on("$destroy", this.GetNewPaymentInfoListener);

    this.cardNumberFormatting = {
      creditCard: true,
      delimiter: "-",
      onValueChanged: (e) => {
        this.cardNumber = e.target.rawValue.trim();
      },
    };

    window.fbOnLogin = () => this.fbSuccessfulLogin();

    window.document.addEventListener("AppleIDSignInOnSuccess", (data) => {
      this.handleAppleSignin(data.detail);
      //handle successful response
    });

    window.document.addEventListener("AppleIDSignInOnFailure", (error) => {
      console.error(error);
      //handle successful response
    });

    FB.init({
      appId: "1097626717272010",
      autoLogAppEvents: true,
      xfbml: true,
      version: "v10.0",
    });

    this.$timeout(() => {
      const target = document.querySelector("div.sms-code-container");

      if (target) {
        target.addEventListener("paste", (event) => {
          let copyCode = (event.clipboardData || window.clipboardData).getData("text");
          copyCode = copyCode.trim();
          if (copyCode.length === 6) {
            this.smsCode_1 = copyCode.charAt(0);
            this.smsCode_2 = copyCode.charAt(1);
            this.smsCode_3 = copyCode.charAt(2);
            this.smsCode_4 = copyCode.charAt(3);
            this.smsCode_5 = copyCode.charAt(4);
            this.smsCode_6 = copyCode.charAt(5);
            for (let i = 0; i <= 5; i++) {
              document.getElementById("sms-code-" + (i + 1)).value = copyCode.charAt(i);
            }
            this.codeEntered(6);
          }
          event.preventDefault();
        });
      }
    }, 1000);
  }

  handleError(error) {
    let message = error.data.message;
    alert(message);
  }

  getPaymentInfo(data, payment_info_just_created) {
    return new Promise((resolve, reject) => {
      this.$profile.getPaymentInfo().then(
        (response) => {
          resolve(response);
        },
        function (error) {
          reject(error);
        }
      );
    });
  }

  skipPayment() {
    this.$timeout(() => {
      this.paymentSkipped = true;
    });
  }

  handlePaymentResponse(payment_infos, payment_info_just_created, data) {
    this.banks = [];
    this.cards = [];
    if (payment_infos && payment_infos.undeletedPaymentInfos && payment_infos.undeletedPaymentInfos.length > 0) {
      this.$timeout(() => {
        this.paymentReady = true;
      });

      let pay_infos_array = payment_infos.undeletedPaymentInfos;
      try {
        try {
          var sorted_array = pay_infos_array.sort(function (a, b) {
            return new Date(b.lastUpdated).getTime() - new Date(a.lastUpdated).getTime();
          });
        } finally {
          sorted_array.forEach((payment_info, index) => {
            if (index === 0) {
              if (payment_info.bankName) {
                this.banks.push(payment_info);
              } else {
                this.cards.push(payment_info);
              }
            }
          });
        }
      } catch (err) {
      } finally {
      }
    } else {
    }
  }

  toggleAddPayment() {
    if (!this.addingPayment && (this.banks.length || this.cards.length)) {
      let c = confirm(`If you save a new payment method, then it will replace your existing ${this.banks.length ? "bank account" : "debit card"}.`);
      if (!c) return;
    }

    this.$timeout(() => {
      this.addingPayment = !this.addingPayment;
    });
  }

  setLoader() {
    this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  validDate(month, year) {
    const today = new Date();
    return parseFloat(month) / 12 + parseFloat(year) >= today.getFullYear() + (today.getMonth() + 1) / 12;
  }

  addCreditCard() {
    if (
      !this.cardNumber ||
      !this.cvc ||
      !this.street ||
      !this.city ||
      !this.state ||
      !this.zipCode ||
      !this.expMonths ||
      !this.expMonths.value ||
      !this.expYears ||
      !this.expYears.value
    ) {
      this.cardTokenError = "All fields are required";
      return console.error("Missing fields");
    }

    // if (!this.validDate(this.expMonths.value, this.expYears.value))
    //     return console.error("Expired card");
    if (this.isSaveCreditCardDisabled === true) {
      return;
    }
    let data = {};

    data.type = "card";
    data.is_replace = !!(this.cards && this.cards.length);
    data.jobbler = this.currentUser;

    this.setLoader();
    this.isSaveCreditCardDisabled = true;
    this.createRecipient(data);
  }

  addBankAccount() {
    const bank_name = this.accountHolderName;
    const bank_routing = this.routingNumber;
    const bank_account = this.accountNumber;

    if (this.isSaveBankAccountDisabled === true) {
      return;
    }

    if (!bank_name || !bank_routing || !bank_account) {
      this.bankTokenError = "All fields are required";
      return console.error("Missing fields");
    }

    let data = {};

    data.type = "bank";
    data.is_replace = !!(this.banks && this.banks.length);
    data.jobbler = this.currentUser;

    this.setLoader();
    this.isSaveBankAccountDisabled = true;
    this.createRecipient(data);
  }

  createRecipient(data) {
    let pl = null;

    this.bankTokenError = null;
    if (data.type === "card") {
      pl = {
        card: {
          number: this.cardNumber,
          exp_month: this.expMonths.value,
          exp_year: this.expYears.value,
          cvc: this.cvc,
          address_line1: this.street,
          address_city: this.city,
          address_state: this.state,
          address_zip: this.zipCode,
          currency: "usd",
        },
      };
    } else {
      pl = {
        bank_account: {
          country: "us",
          currency: "usd",
          account_holder_name: this.accountHolderName,
          account_holder_type: "individual",
          routing_number: this.routingNumber,
          account_number: this.accountNumber,
        },
      };
    }

    this.$security.getToken(pl).then(
      (response) => {
        this.saveRecipient(response.data, pl, data.type);
      },
      (error) => {
        this.handleRecipientError(error, data.type);
        this.unSetLoader();
      }
    );
  }

  handleRecipientError(response, type) {
    const error = response.data.error
      ? response.data.error.message
      : "There was an issue saving your payment information. Please contact an administrator.";

    if (type === "card") this.cardTokenError = error;
    else this.bankTokenError = error;
  }

  saveRecipient(data, payment_info, type) {
    let pl = {};

    if (type === "card") {
      pl.username = this.currentUser.username;
      pl.stripeToken = data.id;
      pl.paymentMethod = "card";
      pl.country = "us";
      pl.currency = "usd";
    } else {
      pl.username = this.currentUser.username;
      pl.stripeToken = data.id;
      pl.paymentMethod = "bank_account";
    }

    this.$security.saveRecipient(pl).then(
      (response) => {
        let data = {};

        if (response.data.status === "error") {
          console.error(response);
          data.response = response;
          data.error = true;
          this.unSetLoader();
          this.$timeout(() => {
            this.$rootScope.$emit("GetNewPaymentInfo", {data});
          });
        } else {
          data.response = response.data;
          this.unSetLoader();

          this.$tracking.reportSubmitProfileStep("job board", this.$profile.STATUS_MAP[this.$profile.PAYMENTS]);

          data.card = type === "card";

          this.$timeout(() => {
            this.$rootScope.$emit("GetNewPaymentInfo", {data});
          });

          this.displayInformativeModal(type, response);
        }

        this.$timeout(() => {
          this.isSaveBankAccountDisabled = false;
        }, 1000);
      },
      (error) => {
        this.unSetLoader();
        alert("There was a fatal error. Please contact an administrator.");
        this.$timeout(() => {
          this.isSaveBankAccountDisabled = false;
        }, 1000);
      }
    );
  }

  displayInformativeModal(type, resp) {
    this.$timeout(() => {
      this.unSetLoader();
    });
    let text = null;
    //https://intercom.help/jobble/en/articles/2065572-is-direct-deposit-the-only-option

    /*
        if (type === "bank") {
            text = "We have added your bank account as your primary method for receiving funds. Please learn more about the different types of payment methods ";
        } else {
            text = "We have added your debit card as your primary method for receiving funds. Please learn more about the different types of payment methods ";
        }
        this.explaination_text = text;
        this.$timeout(() => {
            this.$timeout(() => {
                this.addingPayment = false
            });
            $("#explain-payment-info-new").modal();
        });
        */
  }

  getMostRecentUser() {
    return new Promise((resolve, reject) => {
      resolve(this.$auth.getUserData());
    });
  }

  canUserApplyToShiftBasedJobs(skipQuestions) {
    return new Promise((resolve) => {
      this.getMostRecentUser().then((user) => {
        this.$timeout(() => {
          console.log("this.userProfileStatus");
          console.dir(this.userProfileStatus);

          this.currentUser = user || this.currentUser;
          this.$rootScope.$emit("SetNewUserForJobBoard", {
            user: this.currentUser,
          });

          this.ui_user_model = _.cloneDeep(this.currentUser);

          this.ui_user_model.dateBirth = this.ui_user_model.dateBirth ? this.convertDateToString(this.ui_user_model.dateBirth) : null;
          this.userVerified = this.currentUser.isVerified;

          if (this.userProfileStatus === this.$profile.INPUT_PHONE_NUMBER) {
            this.processUser();
          }

          this.userProfileStatus = this.$profile.getUserProfileScreen(this.currentUser, this.userProfileStatus);

          console.log("this.userProfileStatus");
          console.dir(this.userProfileStatus);

          this.userReady = this.$profile.getUserProfileEligibility(this.currentUser) === this.$profile.APPLY_ELIGIBLE;

          const jobble_types = this.currentUser.notifPref ? this.currentUser.notifPref.jobbleTypes : [];

          if (this.jobble_types && jobble_types) {
            jobble_types.forEach((j) => {
              let jt = this.jobble_types.find((o) => o.id === j.id);
              if (!jt) return;
              jt.selected = true;
              this.pref_jobble_types.push(jt.id);
            });
          }

          if (this.userProfileStatus === this.$profile.WORK_ELIGIBILITY) {
            this.$timeout(() => {
              $(function () {
                $('[data-toggle="tooltip"]').tooltip();
                $("#datepicker").datepicker({
                  changeMonth: true,
                  changeYear: true,
                  minDate: "-100Y",
                  maxDate: "-18Y",
                  yearRange: "-100:-18",
                });
              });
            }, 500);
          }

          resolve();

          if (this.userReady) {
            this.skipPayment();
          }

          if (this.currentUser && this.jobble && !skipQuestions) {
            if (this.jobble.id === this.last_questions_loaded_id && this.questions && this.questions.length) return;

            this.setSurveyQuestionsForJob({data: this.jobble});
          }
        });
      });
    });
  }

  consentToBgCheck(consent) {
    if (!angular.isUndefined(consent)) {
      console.log("consentToBgCheck");
      console.dir(consent);
    }
  }

  setProfilePage(page) {
    if (page > this.$profile.getUserProfileScreen(this.currentUser)) return;

    this.$timeout(() => {
      this.userProfileStatus = page;

      if (page === this.$profile.WORK_ELIGIBILITY) {
        this.$timeout(() => {
          $(function () {
            $('[data-toggle="tooltip"]').tooltip();
            $("#datepicker").datepicker({
              changeMonth: true,
              changeYear: true,
              minDate: "-100Y",
              maxDate: "-18Y",
              yearRange: "-100:-18",
            });
          });
        }, 500);
      }
    });
  }

  uploadProfilePhoto() {
    this.$timeout(() => {
      this.uploadingProfile = true;
    });

    let file = $("#profile-photo-upload")[0].files[0];
    const fd = new FormData();
    fd.append("file", file);

    this.$profile.uploadProfilePicture(fd).then((res) => {
      if (res.status === 200) {
        if (res.data.status === "error") {
          this.$timeout(() => {
            this.uploadingProfile = false;
          });
          this.$timeout(() => {
            alert("There was an issue uploading your profile picture. Please try another photo.");
          }, 300);
        } else {
          this.getPhotos(true);
          this.$tracking.reportSubmitProfileStep("job board", this.$profile.STATUS_MAP[this.$profile.PROFILE_PICTURE]);
        }
      }
    });
  }

  getPhotos(is_profile_picture, init, is_cover_photo, is_edit) {
    this.$profile.getMultiMediaDataWithFormats().then(
      (response) => {
        this.setMultiMediaData(response.data, is_profile_picture, init, is_cover_photo, is_edit);
      },
      function (error) {
        alert("Error grabbing multimedia");
      }
    );
  }

  setMultiMediaData(user, is_profile_picture, init, is_cover_photo, is_edit) {
    let data_model = {};
    data_model.picture_data = this.$profile.getJobblerPictures(user, is_edit, this.model);
    this.model = data_model;

    let left_rail_data = {};

    left_rail_data.image = this.model.picture_data.main_picture;
    left_rail_data.image_only = true;
    left_rail_data.first_name = this.currentUser.firstName;
    left_rail_data.last_name = this.currentUser.lastName;
    this.$timeout(() => {
      this.$timeout(() => {
        this.uploadingProfile = false;
      });
      this.$rootScope.imgFromProfilePage = this.model.picture_data.main_picture;
      this.$rootScope.$emit("SetProfileImageForJobbler", {
        user: left_rail_data,
      });

      this.$auth.refreshCurrentUser().then(() => {
        this.getMostRecentUser((user) => {
          this.$timeout(() => {
            this.currentUser = user || this.currentUser;
            this.ui_user_model = _.cloneDeep(this.currentUser);

            this.ui_user_model.dateBirth = new Date(
              this.ui_user_model.dateBirth ? this.convertDateToString(this.ui_user_model.dateBirth) : "01/01/1940"
            );
          });
        });
      });
    });
  }

  clearQuestions() {
    this.questions = [];
    this.questionsLoaded = false;
  }

  getJobbleTypes() {
    const newFilters = [
      "Logistics",
      "Retail",
      "Warehouse",
      "Light Industrial",
      "Cashier",
      "Delivery",
      "Driver",
      "Stocking",
      "Facility Staff",
      "Restaurant",
      "Hospitality",
      "Housekeeping",
      "Landscaper",
      "Agriculture",
      "Caregiving",
      "Security",
      "Customer Service",
      "Event Staff",
    ];

    return new Promise((resolve) => {
      this.$auth.getJobbleTypes(200).then((data) => {
        this.jobbleTypes = data.data;

        if (data.data) {
          this.jobbleTypes = data.data.filter((type) => {
            return newFilters.indexOf(type.name) !== -1;
          });

          this.jobbleTypes = this.jobbleTypes.sort((a, b) => {
            return newFilters.indexOf(a.name) - newFilters.indexOf(b.name);
          });
        }

        this.$timeout(() => {
          this.jobble_types = this.jobbleTypes;
          this.$rootScope.jobble_types = this.jobbleTypes;
          resolve();
        });
      });
    });
  }

  changePrefJobbleTypes(type, index) {
    try {
      if (this.pref_jobble_types.indexOf(type.id) > -1) {
        let i = this.pref_jobble_types.indexOf(type.id);
        if (this.pref_jobble_types.length > 1) {
          type.selected = false;
          this.pref_jobble_types.splice(i, 1);
        } else {
          alert("You need atleast one preferred jobble type");
        }
      } else {
        this.pref_jobble_types.push(type.id);
        type.selected = true;
      }
    } catch (err) {}
  }

  togglePreferences() {
    this.expandPreferences = !this.expandPreferences;
  }

  convertDateToString(indate) {
    const date = new Date(indate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate() + 1;
    return ((month + "").length === 1 ? "0" + month : month) + "/" + ((day + "").length === 1 ? "0" + day : day) + "/" + year;
  }

  mapFields(inmodel) {
    try {
      const model = JSON.parse(JSON.stringify(inmodel));

      if (model.dateBirth) {
        const date = new Date(model.dateBirth);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        model.dateBirth =
          year + "-" + ((month + "").length === 1 ? "0" + month : month) + "-" + ((day + "").length === 1 ? "0" + day : day) + "T00:00:00Z";
      }

      model.isVerified = undefined;

      return model;
    } catch (e) {
      return inmodel;
    }
  }

  saveAndExit() {
    const model = this.mapFields(this.ui_user_model);

    if (this.userProfileStatus > this.$profile.WORK_ELIGIBILITY) return this.exit();

    let payload = {};

    if (this.userProfileStatus === this.$profile.COMPLETE_PROFILE) {
      payload = this.$profile.extractFields(model, COMPLETE_PROFILE_FIELDS);
    }
    if (this.userProfileStatus === this.$profile.LOCATION) {
      payload = this.$profile.extractFields(model, LOCATION_FIELDS);
    }
    if (this.userProfileStatus === this.$profile.WORK_ELIGIBILITY) {
      payload = this.$profile.extractFields(model, WORK_ELIGIBILITY_FIELDS);
    }

    this.$profile
      .saveUser(payload)
      .then((response) => {
        this.$auth.refreshCurrentUser();
        this.exit();
      })
      .catch((err) => {
        this.$auth.refreshCurrentUser();
        console.error(err);
        this.exit();
      });
  }

  exit() {
    this.$timeout(() => {
      $("#apply-profile-modal").modal("hide");
      this.applicationComplete = false;
      this.applicationError = false;
      this.applicationText = "";
      this.verifyingSMS = false;
      this.errors = {};
    });
  }

  sendSMSLink() {
    if (this.currentUser.homeContactInfo.phoneMobile !== this.ui_user_model.homeContactInfo.phoneMobile) {
      this.$timeout(() => {
        this.verifyingSMS = true;
        this.smsVerified = false;
      });

      const model = this.mapFields(this.ui_user_model);
      let payload = this.$profile.extractFields(model, ["phoneMobile"]);

      this.$profile.saveUser(payload).then((response) => {
        this.$auth.refreshCurrentUser().then((user) => {
          this.getMostRecentUser().then((user) => {
            this.$timeout(() => {
              this.currentUser = user || this.currentUser;

              this.ui_user_model = _.cloneDeep(this.currentUser);
              this.ui_user_model.dateBirth = new Date(this.ui_user_model.dateBirth ? this.ui_user_model.dateBirth.replace("Z", "") : "01/01/1940");

              this.processUser();
            });
          });
        });
      });
    } else {
      this.$timeout(() => {
        this.verifyingSMS = true;
      });
      this.processUser();
    }
  }

  processUser() {
    this.setLoader();

    console.log("processUser");
    console.dir(this.currentUser);
    console.dir(this.currentUser.homeContactInfo);

    if (this.currentUser.homeContactInfo.isMobilePhoneVerified) {
      console.error("This user is already verified.");
      this.$timeout(() => {
        this.smsVerified = true;
        this.sendAppLink();
      });
    } else {
      this.$timeout(() => {
        this.smsVerified = false;
      });

      this.$timeout(() => {
        this.$profile
          .sendSMSCode()
          .then((response) => {
            this.unSetLoader();
            //this.canUserApplyToShiftBasedJobs(true);
          })
          .catch((err) => {
            this.unSetLoader();
          });
      }, 2000);
    }
  }

  sendAppLink(exit) {
    return new Promise((resolve) => {
      let req = {
        method: "POST",
        data: {
          body: "You are a Jobbler now! download the app to enhance your Jobble experience! Download: https://link.jobble.com/download-app",
        },
        url: this.$env.getAPIEndPoint() + "jbl/v1/sms",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$localStorage.logged_user.access_token,
        },
      };

      this.$http(req)
        .then((response) => {
          this.$tracking.reportMobileLinkSent("job board", this.currentUser.email);
          resolve();
          this.unSetLoader();
          if (exit) {
            this.exit();
          }
        })
        .catch((err) => {
          console.error("SMS Error", err);
          this.unSetLoader();
          if (exit) {
            this.exit();
          }
          resolve();
        });
    });
  }

  codeEntered(num) {
    if (num <= 5 && this["smsCode_" + num]) {
      const el = document.getElementById("sms-code-" + (num + 1));
      el.focus();
      el.select();
    }

    let code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;

    if (code.length === 6) {
      this.validateSMSCode();
    }
  }

  resendAppLink() {
    this.$timeout(() => {
      this.smsLinkSending = true;
      this.smsLinkSennt = false;
    });
    this.sendAppLink().then(() => {
      this.$timeout(() => {
        this.smsLinkSending = false;
        this.smsLinkSennt = true;
      });
    });
  }

  validateSMSCode() {
    const code = "" + this.smsCode_1 + this.smsCode_2 + this.smsCode_3 + this.smsCode_4 + this.smsCode_5 + this.smsCode_6;

    this.setLoader();

    this.$profile
      .validateSMSCode(code)
      .then((response) => {
        this.$timeout(() => {
          this.smsVerified = true;
          this.submitAndSaveUser(this.$profile.INPUT_PHONE_NUMBER);
          this.canUserApplyToShiftBasedJobs(true);
          this.sendAppLink();
          this.$tracking.reportSMSVerified("job board", this.currentUser.email);
          this.bootIntercom();
          this.unSetLoader();
        });
      })
      .catch((err) => {
        this.$timeout(() => {
          this.smsVerificationError = true;
          this.smsVerificationErrorText = "Code invalid or expired";
          this.unSetLoader();
        }, 1000);
      });
  }

  consentForm(page) {
    this.savingProfile = true;
    if (this.bgConsent !== true) {
      this.consentToBgCheckAPI(false, page);
    } else {
      this.consentToBgCheckAPI(true, page);
    }
  }

  submitAndSaveUser(page) {
    const model = this.mapFields(this.ui_user_model);

    let payload = model;

    console.log("submitAndSaveUser");
    console.dir(page);
    console.dir(this.currentUser);
    console.dir(payload);
    console.dir(this.$profile);

    if (page) {
      let pageValid = true;

      if (page === this.$profile.COMPLETE_PROFILE) {
        pageValid = this.isValidMultiple(COMPLETE_PROFILE_FIELDS);
        payload = this.$profile.extractFields(model, COMPLETE_PROFILE_FIELDS);
      }

      if (page === this.$profile.VERIFY_PHONE) {
        pageValid = this.isValidMultiple(VERIFY_PHONE_FIELDS);
        payload = this.$profile.extractFields(model, VERIFY_PHONE_FIELDS);
        this.clearInputNumbers();
      }

      if (page === this.$profile.INPUT_PHONE_NUMBER) {
        payload.homeContactInfo.isMobilePhoneVerified = true;
      }

      if (page === this.$profile.LOCATION) {
        pageValid = this.isValidMultiple(LOCATION_FIELDS);
        payload = this.$profile.extractFields(model, LOCATION_FIELDS);
      }

      if (page === this.$profile.WORK_ELIGIBILITY) {
        pageValid = this.isValidMultiple(WORK_ELIGIBILITY_FIELDS);
        payload = this.$profile.extractFields(model, WORK_ELIGIBILITY_FIELDS);

        console.log("pageValid");
        console.dir(pageValid);
        if (this.ui_user_model.ssn !== this.ui_user_model.ssn_confirm) {
          pageValid = false;
          this.errors["ssn_confirm"] = true;
        } else {
          this.errors["ssn_confirm"] = false;
        }
      }

      if (page === this.$profile.BG_CONSENT) {
        payload.acceptedBackgroundCheck = true;
      }

      if (!pageValid) return;
    }

    this.savingProfile = true;
    this.dupeSSN = false;

    var _this = this;

    console.log("payload to server : user");
    console.dir(payload);
    if (page === 6) {
      delete payload.ssn;
    }

    console.log("payload to server : user - after delete");
    console.dir(payload);

    this.$profile.saveUser(payload).then(
      (response) => {
        if (page) this.$tracking.reportSubmitProfileStep("job board", this.$profile.STATUS_MAP[page]);

        this.$timeout(() => {
          this.$auth.refreshCurrentUser().then((user) => {
            this.savingProfile = false;
            if (response.data.status === "error") {
              this.dupeSSN = true;
              alert(response.data.message);
            } else {
              this.canUserApplyToShiftBasedJobs(true);
            }
          });
        }, 1000);
      },
      function (error) {
        console.log("saveUser error : " + error);
        console.dir(error);
        _this.unSetLoader();
        _this.savingProfile = false;

        if (error.data.code === 2205) {
          alert("There was an error with your SSN. Please enter a different SSN.");
        } else if (error.data.code === 2602) {
          alert("You have reached the limit of SSN attempts for today. Please try again in 24 hours.");
        } else if (error.data.code === 2600) {
          alert("SSN to validation can not be empty and must be 9 digits long.");
        } else if (error.data.code === 2601) {
          alert("This is a duplicate SSN found in our system. Please contact support.");
        } else if (error.data.code === 2603) {
          alert("Our SSN validation service is down. Please try again later.");
        } else if (error.data.code === 2207) {
          alert("TIN and Name combination matches IRS EIN records.");
        } else if (error.data.code === 2208) {
          alert("TIN and Name combination matches IRS SSN and EIN records.");
        } else if (error.data.code === 2202) {
          alert("TIN entered is not currently issued.");
        } else if (error.data.code === 3200) {
          alert("This phone number has invalid format. Please enter a 10 digit phone number.");
        } else if (error.data.code === 3201) {
          alert("This phone number already exists. Please login with your existing account.");
        } else {
          alert("Please contact support.");
        }
      }
    );
  }

  consentToBgCheckAPI(copy, page) {
    this.$profile.userConsent(copy).then(
      (response) => {
        this.$timeout(() => {
          this.submitAndSaveUser(page);
        }, 3000);
      },
      function (error) {
        this.$timeout(() => {
          this.submitAndSaveUser(page);
        }, 3000);
      }
    );
  }

  clearInputNumbers() {
    this.smsCode_1 = "";
    this.smsCode_2 = "";
    this.smsCode_3 = "";
    this.smsCode_4 = "";
    this.smsCode_5 = "";
    this.smsCode_6 = "";
    this.smsVerificationError = null;
  }

  sendUserToPartnerPost() {
    this.$jobs.setPartnersPostsInteraction(this.jobble).then(
      (res) => {},
      (err) => {}
    );
    const url = this.jobble.url || this.jobble.partnerPostContent.url || this.jobble.partnerPostContent.cm_url || "/jobs";
    this.$window.open(url);
    $("#apply-profile-modal").modal("hide");
  }

  validateUserRegistration() {
    let validObject = {};

    if (!this.user.email || !EMAILREGEX.test(this.user.email)) {
      validObject.success = false;
      validObject.error = "Please provide valid email.";
    } else if (!this.user.password || this.user.password.length < 8) {
      validObject.success = false;
      validObject.error = "Please provide a password longer than 7 characters.";
    } else {
      validObject.success = true;
    }
    return validObject;
  }

  partnerRegister() {
    this.sendUserToPartnerPost();
    if (this.partnerEmail) {
      this.$localStorage.partnerEmail = this.partnerEmail;
      this.$auth
        .registerMobileUser({
          email: this.partnerEmail,
          isBenjaminUser: true,
        })
        .then((response) => {
          this.$tracking.reportSubmitEmailAlert("job board", this.partnerEmail, this.jobble);
        })
        .catch((err) => {});
    }
  }

  register() {
    this.buttonDisabled = true;
    this.errorTextRegi = false;
    let validated = this.validateUserRegistration();

    if (this.jobble && this.jobble.jobbleType && this.jobble.jobbleType.id && this.user) {
      this.user["notifPref"] = {
        jobbleTypes: [this.jobble.jobbleType.id],
      };
    }

    if (!validated.success) {
      this.errorTextRegi = validated.error;
      this.buttonDisabled = false;
      return;
    }

    const ref = this.jobble ? window.location.origin + "/job/" + this.jobble.id + "?o=1" : window.location.origin + "/jobs";

    if (this.user && this.user.email) {
      var _hsq = window._hsq || [];
      window._hsq = _hsq;
      _hsq.push(["setPath", "/jobs"]);
      _hsq.push(["identify", {email: this.user.email}]);
      _hsq.push(["trackPageView"]);
    }

    this.$auth.registerMobileUser(this.user, ref).then(
      (response) => {
        if (response.data.status === "OK") {
          this.$timeout(() => {
            this.initFB(response);
            this.signin(false, true);
          }, 300);
          this.$tracking.reportSubmitRegistration("job board", this.user.email);
        } else {
          this.$timeout(() => {
            this.buttonDisabled = false;
            if (response.data.message.indexOf("Duplicate entry") > -1) {
              this.errorTextRegi = "This email already exists. Please try another.";
            } else {
              this.errorTextRegi = response.data.message;
            }
          }, 10);
        }
      },
      (error) => {
        alert("Error registering. Please contact support");
      }
    );
  }

  initFB(response, isLogin) {
    this.$social.initFB();
    if (isLogin) {
      this.fbTrackLogin(response);
    } else {
      this.fbTrackRegistration(response);
    }
  }

  fbTrackLogin(response) {
    let data = {
      userId: response.data.id,
      userName: response.data.email,
      userEmail: response.data.email,
    };
    this.$social.fbTrackLogin(data);
  }

  fbTrackRegistration(response) {
    let data = {
      userId: response.data.userId,
      userName: this.user.email,
      userEmail: this.user.email,
    };
    this.$social.fbTrackRegistration(data);
  }

  signin(is_direct_signin, is_registration) {
    this.signinError = false;

    if (is_direct_signin) {
      this.buttonDisabled = true;
    }

    this.$auth.lazyLoginMobileUser(this.user).then(
      (response) => {
        this.noUser = false;

        this.$timeout(() => {
          this.userVerified = response.data.isVerified;
          this.currentUser = response.data;
          this.$auth.setMostRecentUser(response.data);
          this.$auth.emitMostRecentUser();

          if (is_registration) {
            this.detectDevice(response.data, "register");
          } else {
            this.detectDevice(response.data, "signin");
          }
          this.buttonDisabled = false;
          this.$rootScope.$emit("SetNewUserForJobBoard", {
            user: this.currentUser,
          });
          this.$rootScope.$emit("SetNewUserForJobBoardHeader", {
            user: this.currentUser,
          });

          this.canUserApplyToShiftBasedJobs();

          this.$tracking.reportJobblerSignUpModal(response.data);
          this.initFB(response, true);
          if (this.payload.data) {
            this.connect();
          }
        }, 10);
      },
      (error) => {
        this.userVerified = false;
        this.buttonDisabled = false;
        this.signinError = "Login failed. Please check your credentials and try again.";
      }
    );
  }

  connect() {
    var _this = this;

    let data = {};

    data.type = this.payload.data.connectedAccountType;
    data.token = this.payload.data.connectedAccountToken;

    _this.$signon.connect(data, this.currentUser).then(
      function (response) {},
      function (error) {}
    );
  }

  resendEmail() {
    this.emailSending = true;

    this.$profile.resendEmail(this.currentUser).then(
      (response) => {
        this.$timeout(() => {
          this.emailSending = false;
          this.emailSent = true;
        });
        this.emailSent = true;
      },
      function (error) {
        this.$timeout(() => {
          this.emailSending = false;
          this.emailSent = false;
        });
      }
    );
  }

  smsAgreement(agreed) {
    let user = {tcpaConsent: agreed};
    this.setLoader();
    this.$profile.saveUserBasic(user).then((response) => {
      this.unSetLoader();
    },
    (error) => {
      this.unSetLoader();
    });
  }

  setSurveyQuestionsForJob(job) {
    this.questionsLoaded = false;
    this.showReqs = false;

    if (job) {
      this.jobble = job.data;
    }

    this.$jobs.getSurveyQuestions(this.jobble.id, this.currentUser).then(
      (response) => {
        this.last_questions_loaded_id = this.jobble.id;

        if (response.data.subEvent.event.surveyQuestions.length > 1) {
          this.last_questions_loaded_id = this.sortQuestions(response.data.subEvent.event.surveyQuestions).then((questions) => {
            this.setQuest(questions);
          });
        } else if (response.data.subEvent.event.surveyQuestions.length === 1) {
          this.setQuest(response.data.subEvent.event.surveyQuestions);
        } else {
          let standardQuestion = {};
          standardQuestion.question = "Can you make all the shifts?";
          standardQuestion.isStandard = true;
          let questionsArray = [];
          questionsArray.push(standardQuestion);
          this.setQuest(questionsArray);
        }
      },
      (error) => {
        this.questionsLoaded = false;
      }
    );
  }

  sortQuestions(questions) {
    return new Promise((resolve) => {
      if (!questions[0].displayOrder) {
        try {
          questions.forEach((question) => {
            let questionNameArray = question.name.split(" ");
            question.position = questionNameArray[1];
            question.position = parseInt(question.position, 10);
          });
        } finally {
          questions.sort((a, b) => {
            return a.position - b.position;
          });
        }
      } else {
        questions.sort((a, b) => {
          return a.displayOrder - b.displayOrder;
        });
      }

      resolve(questions);
    });
  }

  setQuest(questions) {
    let shifts = this.jobble.shifts;

    this.$timeout(() => {
      this.questions = questions;
      console.log("this.questions");
      console.dir(this.questions);
      this.questionsLoaded = true;
      this.buttonDisabled = false;
      this.applicationComplete = false;
      this.applicationError = false;
      this.applicationText = "";
      this.verifyingSMS = false;
      this.smsLinkSending = false;
      this.smsLinkSennt = false;

      let totalHours = 0;
      let totalMinutes = 0;

      shifts.forEach(function (shift) {
        totalHours = shift.payableHours + totalHours;
        totalMinutes = shift.payableMins + totalMinutes;
      });

      totalHours = totalHours + totalMinutes / 60;
      this.totalPayableHours = totalHours;
      this.estimatedTotalPayables = this.jobble.jobblerRate * this.totalPayableHours;
    });
  }

  backToPhoneVerification() {
    this.$timeout(() => {
      this.userProfileStatus = this.$profile.VERIFY_PHONE;
    });
  }

  backToSuccess() {
    this.$timeout(() => {
      this.verifyingSMS = false;
    });
  }

  onQuestionChange(q) {
    q.error = false;
    q.errorText = "";
    this.errorText = "";
  }

  setRequirements() {
    let complete = true;

    if (this.applicationIsSending === true) {
      return;
    }

    this.setLoader();

    this.applicationIsSending = true;

    console.log("set req");
    console.dir(this.questions);

    this.questions = this.questions.map((q) => {
      if (!q.answer) {
        complete = false;
        q.errorText = "Required Question";
        q.error = true;
      }
      return q;
    });
    /*
    if (!complete) {
      this.errorText = "Please complete all questions.";
      this.unSetLoader();
      this.applicationIsSending = false;
      return;
    }
    */

    this.errorText = null;
    let user_not_verified = false;

    if (!this.currentUser.isVerified || this.currentUser.isVerified === false) {
      user_not_verified = true;
    }

    this.getRequirements(user_not_verified);
  }

  getRequirements(user_not_verified) {

    console.log("getRequirements");
    console.dir(user_not_verified);

    var _this = this;

    let data = {};

    if (_this.jobble.subEvent) {
      data.eventId = _this.jobble.subEvent.event.id;
    } else {
      data.eventId = _this.jobble.eventId;
    }

    _this.$jobs.getRequirements(data).then(
      function (response) {
        console.log("repsonse from requirements");
        console.dir(response);
        _this.handleRequirements(response.data, user_not_verified);

        _this.$timeout(function () {
          _this.unSetLoader();
        }, 300);
      },
      function (error) {
        _this.$timeout(function () {
          _this.reqsLoaded = true;
          _this.unSetLoader();
        }, 300);
      }
    );
  }

  handleRequirements(data, user_not_verified) {
    var _this = this;

    let requirements = null;

    if (data.length > 0) {
      _this.showReqs = true;
      requirements = data.sort((a, b) => {
        return a.position - b.position;
      });

      _this.requirements = requirements;
      _this.reqsLoaded = true;
    } else {
      _this.applyNew(user_not_verified);
    }
  }

  checkReq(req) {
    if (req.isChecked === true) {
      req.isChecked = false;
    } else {
      req.isChecked = true;
    }
  }

  validateReqs() {
    let result = true;

    try {
      this.requirements.forEach(function (r) {
        if (r.isChecked !== true) {
          result = false;
        }
      });
    } catch (error) {
    } finally {
    }

    return result;
  }

  showReqInfo() {
    this.displayReqInfo = true;
  }

  applyNew(user_not_verified) {
    if (this.applicationDisabled === true) {
      return;
    } else {
      this.applicationDisabled = true;
    }

    if (this.requirements) {
      if (this.requirements.length > 0) {
        let reqVal = this.validateReqs();

        if (reqVal === false) {
          this.showReqError = "Please select each requirement";
          this.applicationDisabled = false;
          return;
        } else {
          this.showReqError = null;
        }
      }
    }

    this.setLoader();

    if (user_not_verified === true || this.currentUser.isVerified === false) {
      this.unSetLoader();
      alert("Please verify your email before finishing application.");
      return;
    }

    this.$jobs
      .applyToJob(this.questions, this.jobble.id, user_not_verified, this.currentUser)
      .then(
        (response) => {
          this.handleResponse(response);
          this.applicationIsSending = false;

          if (response.data.status !== "error") {
            let user = this.currentUser;
            this.$tracking.reportSubmitApplication("job board", this.jobble);
            this.detectDevice(user);
            if (user) {
              let job = this.jobble;
              let data = this.$iterable.set_data(null, job, user, "apply");
              this.track_jobble_apply(data);
            }
          }
        },
        (error) => {
          console.error(error);
          this.unSetLoader();
          alert("in error when applying");
        }
      )
      .catch((err) => {
        console.error(err);
        this.unSetLoader();
        alert("in error when applying");
      });

    this.$timeout(() => {
      this.applicationDisabled = false;
      this.unSetLoader();
    }, 500);
  }

  handleResponse(response) {
    this.$timeout(() => {
      this.applicationComplete = true;
      console.log("handleResponse");
      console.dir(response);
      if (response.data.status === "error") {
        if (response.data.message === "Applicant already applied for jobble in the pool") {
          this.applicationText = "You already applied to this job. Please pick another.";
        } else if (response.data.message === "Sorry, you've already been booked to work a different jobble on this time frame.") {
          this.applicationText = "Sorry, you've already been booked to work a different job on this time frame.";
        } else if (response.data.message === "The mobile app needs to be downloaded.") {
          this.applicationText = "Sorry, you must download the mobile app to finish your application.";
        } else {
          this.applicationText = "There was an issue with your application. Please try again later.";
        }
        this.applicationError = true;
      } else {
        this.applicationText = "Success! Check your application status on our mobile app.";
        this.applicationError = false;
      }
    }, 300);
  }

  track_jobble_apply(data) {
    this.$iterable.track_jobble_apply(data).then(
      (response) => {},
      (error) => {}
    );
  }

  verify(dontShowWarning) {
    var _this = this;
    this.isVerifying = true;
    this.$auth.reloadCurrentMobileUser().then(
      (response) => {
        this.$timeout(() => {
          if (!response.data.isVerified) {
            this.isVerifying = false;
            if (!dontShowWarning) {
              this.errorText = "The verification link in your email has not been clicked.";
              this.error = true;
              this.$timeout(() => {
                this.error = false;
                this.errorText = undefined;
              }, 3000);
            } else {
            }
          } else {
            this.setSurveyQuestionsForJob();
            this.$timeout(() => {
              this.isVerifying = false;
              this.userVerified = true;
              this.currentUser.isVerified = true;
              this.setVerificationNoti = false;
              this.$rootScope.$emit("SetNewUserForJobBoard", {
                user: _this.currentUser,
              });
              this.$localStorage.logged_user.isVerified = true;
            }, 2500);
          }
        }, 1000);
      },
      (error) => {
        alert("Error validating user");
      }
    );
  }

  showLogin() {
    this.$timeout(() => {
      this.loggingIn = true;
    });
  }

  showRegistrationModal() {
    this.$timeout(() => {
      this.loggingIn = false;
    });
  }

  detectDevice(user, page) {
    let tracking_data = {};
    tracking_data.email = user.email;

    let device_info = this.$security.detectDevice();
    tracking_data.mobile_device_type = device_info.mobile_device_type;
    tracking_data.user_agent = device_info.user_agent;

    if (page === "register") {
      this.$tracking.reportMobileRegisterFromModal(tracking_data);
    } else if (page === "signin") {
      this.$tracking.reportMobileSigninFromModal(tracking_data);
    } else {
      this.$tracking.reportMobileApplication(tracking_data);
    }
  }

  formChange(field, page) {
    this.errors = this.errors || {};

    this.$timeout(() => {
      this.errors = this.$profile.validateProfile(this.ui_user_model, field, this.errors);
    });
  }

  isValidMultiple(fields) {
    let valid = true;

    fields.forEach((field) => {
      this.errors = this.$profile.validateProfile(this.ui_user_model, field, this.errors);
      if (this.errors[field]) valid = false;
    });

    return valid;
  }

  openTab(site) {
    if (site === "google") {
      this.$window.open("https://play.google.com/store/apps/details?id=com.jobble.jobble&hl=en_US&gl=US", "_blank");
      this.$tracking.reportMobileDownload("job board", this.currentUser.email, "google");
    } else if (site === "apple") {
      this.$window.open("https://apps.apple.com/us/app/jobble/id961838757", "_blank");
      this.$tracking.reportMobileDownload("job board", this.currentUser.email, "apple");
    }

    this.exit();
  }

  loadSignOnButtons(error) {
    this.setLoader();
    this.renderGoogle();
    this.renderFacebook();
    this.renderApple();

    this.$timeout(() => {
      this.unSetLoader();
    }, 1300);

    if (error) {
      this.$timeout(() => {
        alert("Please select the correct login provider. " + error);
      }, 2000);
    }
  }

  renderApple() {
    this.$timeout(() => {
      AppleID.auth.init({
        clientId: this.$env.EnvironmentConfig.thirdPartySignon.apple,
        redirectURI: this.$env.EnvironmentConfig.thirdPartySignon.appleRedirectUrl,
        scope: "name email",
        usePopup: true, //or false defaults to false
      });
    }, 1000);
  }

  renderGoogle() {
    let data = {};
    let dataForLogin = {};

    var _this = this;

    this.$timeout(() => {
      gapi.load("auth2", function () {
        // Loads the auth2 component of gapi

        gapi.auth2
          .init({
            // initialize the auth2 using your credentials
            client_id: _this.$env.EnvironmentConfig.thirdPartySignon.google,
          })
          .then(function onInit() {
            // on complete of init

            gapi.signin2.render("g-signin2", {
              scope: "profile email",
              width: 274,
              height: 40,
              longtitle: true,
              theme: "dark",
              onsuccess: function (googleUser) {
                // This executes when a user successfully authorizes you to their data by clicking the button and selecting their account.
                var profile = googleUser.getBasicProfile();

                dataForLogin.connectedAccountType = "GOOGLE";
                data.connectedAccountType = "GOOGLE";
                data.username = profile.getEmail();
                data.firstName = profile.getGivenName();
                data.lastName = profile.getFamilyName();

                if (googleUser.tc) {
                  dataForLogin.connectedAccountToken = googleUser.tc.id_token;
                  data.connectedAccountToken = googleUser.tc.id_token;
                } else if (googleUser.uc) {
                  dataForLogin.connectedAccountToken = googleUser.uc.id_token;
                  data.connectedAccountToken = googleUser.uc.id_token;
                } else if (googleUser.qc) {
                  dataForLogin.connectedAccountToken = googleUser.qc.id_token;
                  data.connectedAccountToken = googleUser.qc.id_token;
                }

                _this.login(data, dataForLogin);
              },
            });
          });
      });
    }, 300);
  }

  renderFacebook() {
    var Cbuild1 = null;

    this.$timeout(() => {
      Cbuild1 = document.getElementById("fbloginonboard");
      Cbuild1.innerHTML =
        "<fb:login-button scope='email' onlogin='window.fbOnLogin()' data-width='274' data-size='large' data-button-type='continue_with' data-layout='default' data-auto-logout-link='false' data-use-continue-as='false'></fb:login-button>";
      FB.XFBML.parse(Cbuild1);
    }, 500);
  }

  handleAppleSignin(response) {
    let data = {};
    let dataForLogin = {};

    if (response.user) {
      data.username = response.user.email;
      data.firstName = response.user.name.firstName;
      data.lastName = response.user.name.lastName;
      data.connectedAccountType = "APPLE";
      data.connectedAccountToken = response.authorization.id_token;

      dataForLogin.connectedAccountType = "APPLE";
      dataForLogin.connectedAccountToken = response.authorization.id_token;

      this.registerThirdParty(data, dataForLogin, "apple");
    } else {
      alert("No email was returned from apple");
    }
  }

  setValidation({field, valid, message}) {
    if (this.canValidate) {
      this.$timeout(() => {
        this.validation[field] = {
          valid,
          style: {borderColor: valid ? "green" : "red"},
          message,
        };
      });
    }
  }

  confirmEmail(data, dataForLogin, needEmailConfirmation) {
    if (needEmailConfirmation === true) {
      this.payload.needEmailConfirmation = true;
      this.payload.data = data;
      this.payload.dataForLogin = dataForLogin;
    }

    this.$timeout(() => {
      this.confirmEmailBool = true;
      this.signOnEmail = data.username;
    });
  }

  sendConfirmedEmail() {
    this.payload.data.username = this.signOnEmail;

    let data = this.payload.data;
    let dataForLogin = this.payload.dataForLogin;

    this.registerThirdParty(data, dataForLogin, false);
  }

  registerThirdParty(data, dataForLogin, needEmailConfirmation) {
    var _this = this;

    let handleAppleScreen = false;

    if (this.registering === true) {
      console.log("are we here?");
      return;
    }

    if (needEmailConfirmation === true) {
      _this.confirmEmail(data, dataForLogin, needEmailConfirmation);
      return;
    }

    if (needEmailConfirmation === "apple") {
      handleAppleScreen = true;
      dataForLogin.handleAppleScreen = handleAppleScreen;
      dataForLogin.appleUsername = data.username;
    }

    this.registering = true;
    this.setLoader();

    _this.$signon.register(data, dataForLogin).then(
      function (response) {
        if (response.data.message.indexOf("Duplicate entry") > -1) {
          _this.sendUserToSignIn(data, dataForLogin);
        } else if (response.data.message.indexOf("The email provided is already connected") > -1) {
          _this.confirmEmailBool = false;
          _this.loadSignOnButtons(response.data.message);
        } else if (response.data.message === "The registration email was successfully sent") {
          _this.$timeout(function () {
            _this.registering = false;
            _this.login(data, dataForLogin);
          }, 500);
        } else {
        }
      },
      function (error) {
        _this.registering = false;
        alert("There was an error with your registration. Please try again later.");
      }
    );
  }

  login(data, dataForLogin) {
    var _this = this;

    _this.$signon.login(data, dataForLogin).then(
      function (response) {
        console.log("what is the response");
        console.dir(response);
        if (response.data.access_token) {
          _this.userVerified = response.data.isVerified;
          _this.currentUser = response.data;
          _this.$auth.setMostRecentUser(response.data);
          _this.$auth.emitMostRecentUser();
          response.data.type = dataForLogin.connectedAccountType;
          _this.$tracking.reportJobblerSignUpThirdPartyOnboarding(response.data);
          _this.sendUser(response, dataForLogin);
          _this.unSetLoader();
        }
      },
      function (error) {
        console.log("error");
        console.dir(error);
        if (error.status === 401) {
          _this.unSetLoader();
          _this.registerThirdParty(data, dataForLogin, true);
        } else {
          _this.unSetLoader();
        }
      }
    );
  }

  sendUserToSignIn(data, dataForLogin) {
    this.userNeedsToSignIn = true;
    this.noUser = true;
    this.loggingIn = true;
    this.confirmEmailBool = false;
    this.payload.data = data;
    this.user.email = data.username;
    this.payload.dataForLogin = dataForLogin;
    this.signinError =
      "The email " + data.username + " already exists. Please login by entering your password to connect your Jobble account to third party service.";
  }

  sendUser(response, dataForLogin) {
    let user = {};

    if (response.data.company) {
      this.$state.go("events");
      return;
    }

    user = response.data;

    this.$localStorage.logged_user = response.data;
    this.currentUser = response.data;
    this.currentUser.homeContactInfo = {};
    this.noUser = false;

    if (this.currentUser.isVerified !== true) {
      this.confirmEmailBool = true;
    } else {
      this.canUserApplyToShiftBasedJobs();
    }

    this.$timeout(() => {
      if (dataForLogin.handleAppleScreen === true) {
        alert(
          "Account created using " +
            dataForLogin.appleUsername +
            ". If you would like Jobble to send important messages to a different email address you can change it in your profile."
        );
      }
    }, 300);
  }

  fbSuccessfulLogin() {
    let data = {};
    let dataForLogin = {};

    var _this = this;

    FB.getLoginStatus(function (response) {
      var fbResponse = response;

      if (response.status === "connected") {
        _this.setLoader();

        FB.api("/me?fields=name,email,first_name,last_name", function (response) {
          _this.unSetLoader();
          if (!response.email) {
            _this.handleFaceBookNoEmail(response, fbResponse);
          } else {
            if (fbResponse.authResponse.accessToken) {
              dataForLogin.connectedAccountType = "FACEBOOK";
              dataForLogin.connectedAccountToken = fbResponse.authResponse.accessToken;
              data.username = response.email;
              data.firstName = response.first_name;
              data.lastName = response.last_name;
              data.connectedAccountType = "FACEBOOK";
              data.connectedAccountToken = fbResponse.authResponse.accessToken;
              _this.login(data, dataForLogin);
            }
          }
        });
      }
    });
  }

  bootIntercom() {
    console.log("boot intercom");
    console.dir(this.window);
    console.dir(this.$window);

    if (this.currentUser) {
      this.$window.Intercom("boot", {
        app_id: "och30e8r",
        email: this.currentUser.email,
        user_id: this.currentUser.id,
        created_at: 1234567890,
      });
    }
  }

  smsCodeBackSpace(event, inputSequence) {
    if (event.keyCode === 8) {
      if (inputSequence !== 1) {
        let activeValue = $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + inputSequence).val();
        if (activeValue === "") {
          this.$timeout(() => {
            $(".apply-profile-modal .modal-content .sms-code-container input#sms-code-" + (inputSequence - 1)).focus();
          });
        }
      }
    }
  }
}

ApplyProfileModalController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "security",
  "signon",
  "signup.validator",
  "tracking",
  "$rootScope",
  "$scope",
  "$location",
  "$timeout",
  "$window",
  "companies",
  "messagingv2",
  "events",
  "jobs",
  "social",
  "iterable",
  "profile",
  "env",
  "validation",
];

export default ApplyProfileModalController;



// WEBPACK FOOTER //
// ./client/app/common/applyProfileModal/applyProfileModal.controller.js